<template>
  <div id="move-buttons" v-bind:style="style">
    <template v-for="(symbol, moveId) in directions" v-bind:key="moveId">
      <button
        v-if="isAvailable(moveId)"
        v-bind:id="moveId"
        v-on:click="$emit('move', moveId)"
      >
        {{ symbol }}
      </button>
    </template>
  </div>
</template>

<script>
import { MOVES } from "@/constants";

export default {
  name: "TheMoveSelection",
  props: {
    cellSize: {
      type: Number,
      required: true
    },
    buttonSize: {
      type: Number,
      required: true
    },
    fieldValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      directions: {
        LEFT: "-",
        LEFT_TOP: "\\",
        TOP: "|",
        RIGHT_TOP: "/",
        RIGHT: "-",
        RIGHT_BOTTOM: "\\",
        BOTTOM: "|",
        LEFT_BOTTOM: "/"
      }
    };
  },
  computed: {
    style() {
      const size = `${this.cellSize * 3}px`;
      return {
        "--cell-size": `${this.cellSize}px`,
        "--button-size": `${this.buttonSize}px`,
        width: size,
        height: size
      };
    }
  },
  methods: {
    isAvailable(moveId) {
      return !(this.fieldValue & MOVES[moveId]);
    }
  }
};
</script>

<style scoped lang="sass">
#move-buttons
  position: relative

button
  position: absolute
  width: var(--button-size)
  height: var(--button-size)

#LEFT_TOP
  top: 0
  left: 0

#TOP
  top: 0
  left: calc(var(--cell-size) * 1)

#RIGHT_TOP
  top: 0
  left: calc(var(--cell-size) * 2)

#RIGHT
  top: calc(var(--cell-size) * 1)
  left: calc(var(--cell-size) * 2)

#RIGHT_BOTTOM
  top: calc(var(--cell-size) * 2)
  left: calc(var(--cell-size) * 2)

#BOTTOM
  top: calc(var(--cell-size) * 2)
  left: calc(var(--cell-size) * 1)

#LEFT_BOTTOM
  top: calc(var(--cell-size) * 2)
  left: 0

#LEFT
  top: calc(var(--cell-size) * 1)
  left: 0
</style>
